import { render, staticRenderFns } from "./LegacyPortfolioOverlay.vue?vue&type=template&id=2e4c584d&"
import script from "./LegacyPortfolioOverlay.vue?vue&type=script&lang=js&"
export * from "./LegacyPortfolioOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports